import { KEYBOARD, TOUCH } from './controls'
import type { ControlRow } from './controls'
import styles from './controlsHelp.module.css'
import settings from './settings.module.css'

function Rows({ title, rows }: { title: string; rows: readonly ControlRow[] }) {
  return (
    <section class={styles.helpColumn} aria-label={title}>
      <h2 class={settings.sectionTitle}>{title}</h2>
      <dl class={styles.helpList}>
        {rows.map((r) => (
          <div key={r.action} class={styles.helpRow}>
            <dt>{r.action}</dt>
            <dd>
              {r.keys.map((k) => (
                <kbd key={k.code} class={styles.key}>
                  {k.label}
                </kbd>
              ))}
              {r.note && <span class={styles.helpNote}>{r.note}</span>}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  )
}

/** The controls help (PHASE3 T3.7): keyboard and touch side by side. */
export function ControlsHelp() {
  return (
    <div class={styles.help}>
      <Rows title="Keyboard" rows={KEYBOARD} />
      <Rows title="Touch" rows={TOUCH} />
    </div>
  )
}
